import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router';
import { selectedDateWithoutTime } from '@store/global/selectors';
import { selectValidParams, selectDateRange, selectGridData } from '@pages/reporting-pages/deliveries-trades-district/store/selectors';
import { TradesDistrictParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { setSearchParameters, setDateRange } from '@pages/reporting-pages/deliveries-trades-district/store/slice';
import { DateRange } from '@project-types/DateRange';
import { useResetDeliveriesTradesDistrictMutation } from '@api/order-reporting/deliveryApi';
import { AppPage } from 'components/app-page/AppPage';
import ParamsToolbar from '@pages/reporting-pages/deliveries-trades-district/params-toolbar/ParamsToolbar';
import Grid from '@pages/reporting-pages/deliveries-trades-district/grid/Grid';
import { headersObject } from '@pages/reporting-pages/deliveries-trades-district/headersObject';



const DeliveriesTradesDistrict = () => {

	const validParams = useSelector(selectValidParams);
	const dateWithoutTime = useSelector(selectedDateWithoutTime);
	const dateRange = useSelector(selectDateRange);
	const gridData = useSelector(selectGridData);

	const [ search, setSearch ] = useSearchParams();
	const dispatch = useDispatch();
	const updateSearchParameters = (parameters: TradesDistrictParams) => dispatch(setSearchParameters(parameters));
	const updateDateRange = (dateRange: DateRange) => dispatch(setDateRange(dateRange));

	const [ runReset ] = useResetDeliveriesTradesDistrictMutation();


	useEffect(() => {
		if (!dateRange) {
			updateDateRange({ from: dateWithoutTime, to: dateWithoutTime });
		}
	}, []);

	
	useEffect(() => {
		if (validParams) {
			setSearch({ ...validParams }, { replace: true });
		}
	}, [ validParams ]);

	
	useEffect(() => {
		if (search) {
			let paramDateFrom = search.get('dateFrom');
			let paramDateTo = search.get('dateTo');

			if (!paramDateFrom || !paramDateTo) return;

			let newSearchParams: TradesDistrictParams = {
				dateFrom: paramDateFrom,
				dateTo: paramDateTo,
			}
			updateSearchParameters(newSearchParams);
		}
	}, [ search ]);


	const resetAllApi = useCallback(() => {
		runReset();
	},[]);


	return (
		<AppPage
			className='reporting-page deliveries-trades-district'
			pageLabel='Report dodávek - Trades District'
			resetPageApi={resetAllApi}
			csvData={{
				headers: headersObject,
				data: gridData,
				filename: 'reporting-dodavky-trades-district'
			}}
		>
			<ParamsToolbar />
			<Grid />
		</AppPage>
	)
};

export default DeliveriesTradesDistrict;